import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('restaurant');

const GET_RESTAURANTS = define('GET_RESTAURANTS', true);
const GET_RESTAURANT = define('GET_RESTAURANT', true);
const CREATE_RESTAURANT = define('CREATE_RESTAURANT', true);
const UPDATE_RESTAURANT = define('UPDATE_RESTAURANT', true);
const DELETE_RESTAURANT = define('DELETE_RESTAURANT', true);

const initialState = {
  isLoading: true,
  restaurants: [],
  restaurant: {},
  processing: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RESTAURANTS.PENDING:
    case GET_RESTAURANTS.REJECTED:
    case GET_RESTAURANT.PENDING:
    case GET_RESTAURANT.REJECTED:
      return {
        ...state,
        isLoading: true
      };
    case GET_RESTAURANTS.RESOLVED:
      return {
        ...state,
        isLoading: false,
        restaurants: action.data
      };
    case GET_RESTAURANT.RESOLVED:
      return {
        ...state,
        isLoading: false,
        restaurant: action.data
      };
    case UPDATE_RESTAURANT.PENDING:
    case DELETE_RESTAURANT.PENDING:
      return {
        ...state,
        processing: true
      };
    case UPDATE_RESTAURANT.RESOLVED:
    case UPDATE_RESTAURANT.REJECTED:
    case DELETE_RESTAURANT.RESOLVED:
    case DELETE_RESTAURANT.REJECTED:
      return {
        ...state,
        processing: false
      };
    default: return state;
  }
};

export const actions = {
  getRestaurants: () => ({
    type: GET_RESTAURANTS,
    promise: api.get('/restaurant'),
    error: 'Unable to get restaurants'
  }),
  getRestaurant: (id) => ({
    type: GET_RESTAURANT,
    promise: api.get(`/restaurant/${id}`),
    error: 'Unable to get restaurants'
  }),
  createRestaurant: data => ({
    type: CREATE_RESTAURANT,
    promise: api.post('/restaurant', data),
    success: 'Restaurant has been created',
    error: 'Unable to create restaurant'
  }),
  updateRestaurant: (id, data) => ({
    type: UPDATE_RESTAURANT,
    promise: api.put(`/restaurant/${id}`, data),
    success: 'Restaurant has been updated',
    error: 'Unable to update restaurant'
  }),
  deleteRestaurant: id => ({
    type: DELETE_RESTAURANT,
    promise: api.delete(`/restaurant/${id}`),
    success: 'Restaurant has been deleted',
    error: 'Unable to delete restaurant'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/restaurant.js